// extracted by mini-css-extract-plugin
module.exports = {"cursor":"ReloveIconComment_cursor__-o59u","root":"ReloveIconComment_root__su_LZ"};